const STAGE_SEQUENCE = [
  { name: "processar", order: 1 },
  { name: "mapear", order: 2 },
  { name: "correlacionar", order: 3 },
  { name: "incluir", order: 4 },
  { name: "atualizar_cache", order: 5 },
  { name: "verificar", order: 6 },
  { name: "incluir_hub", order: 7 },
]

const RUNS = [
  {
    id: 124,
    created_at: "2026-01-12T16:00:02Z",
    updated_at: "2026-01-12T16:42:31Z",
    started_at: "2026-01-12T16:00:04Z",
    finished_at: null,
    status: "running",
    mode: "hdi",
    limit: null,
    requested_by: 7,
    input_name: "HDI_2026_ORIGINAL.xlsx",
    input_s3_key: "nf_docs/runs/124/input/HDI_2026_ORIGINAL.xlsx",
    current_planilha_s3_key: "nf_docs/runs/124/stage/incluir/planilha.xlsx",
    output_s3_key: "",
    current_stage: "incluir",
    pause_requested: false,
    error_message: "",
    run_config: { workers: 8, mode: "hdi", dry_run: false, import_enabled: true, import_ref: "" },
    stages: [
      {
        id: 501,
        name: "processar",
        order: 1,
        status: "completed",
        total_items: 2076,
        processed_items: 2076,
        success_items: 2068,
        error_items: 8,
        skipped_items: 0,
        started_at: "2026-01-12T16:00:04Z",
        finished_at: "2026-01-12T16:07:32Z",
        error_message: "",
        checkpoint: {},
      },
      {
        id: 502,
        name: "mapear",
        order: 2,
        status: "completed",
        total_items: 105,
        processed_items: 105,
        success_items: 105,
        error_items: 0,
        skipped_items: 0,
        started_at: "2026-01-12T16:07:33Z",
        finished_at: "2026-01-12T16:12:25Z",
        error_message: "",
        checkpoint: { total_paginas: 105 },
      },
      {
        id: 503,
        name: "correlacionar",
        order: 3,
        status: "completed",
        total_items: 2079,
        processed_items: 2079,
        success_items: 2068,
        error_items: 0,
        skipped_items: 11,
        started_at: "2026-01-12T16:12:26Z",
        finished_at: "2026-01-12T16:18:44Z",
        error_message: "",
        checkpoint: {},
      },
      {
        id: 504,
        name: "incluir",
        order: 4,
        status: "running",
        total_items: 2068,
        processed_items: 420,
        success_items: 410,
        error_items: 4,
        skipped_items: 6,
        started_at: "2026-01-12T16:18:45Z",
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
      {
        id: 505,
        name: "atualizar_cache",
        order: 5,
        status: "pending",
        total_items: 0,
        processed_items: 0,
        success_items: 0,
        error_items: 0,
        skipped_items: 0,
        started_at: null,
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
      {
        id: 506,
        name: "verificar",
        order: 6,
        status: "pending",
        total_items: 0,
        processed_items: 0,
        success_items: 0,
        error_items: 0,
        skipped_items: 0,
        started_at: null,
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
      {
        id: 507,
        name: "incluir_hub",
        order: 7,
        status: "pending",
        total_items: 0,
        processed_items: 0,
        success_items: 0,
        error_items: 0,
        skipped_items: 0,
        started_at: null,
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
    ],
  },
  {
    id: 123,
    created_at: "2026-01-09T09:14:10Z",
    updated_at: "2026-01-09T10:02:50Z",
    started_at: "2026-01-09T09:14:12Z",
    finished_at: "2026-01-09T10:02:50Z",
    status: "completed",
    mode: "hdi",
    limit: 60,
    requested_by: 7,
    input_name: "HDI_2026_ORIGINAL.xlsx",
    input_s3_key: "nf_docs/runs/123/input/HDI_2026_ORIGINAL.xlsx",
    current_planilha_s3_key: "nf_docs/runs/123/stage/verificar/planilha.xlsx",
    output_s3_key: "nf_docs/runs/123/stage/verificar/planilha.xlsx",
    current_stage: "verificar",
    pause_requested: false,
    error_message: "",
    run_config: { workers: 8, mode: "hdi", dry_run: false, import_enabled: true, import_ref: "Batch HDI 09/01" },
    stages: [
      {
        id: 401,
        name: "processar",
        order: 1,
        status: "completed",
        total_items: 2076,
        processed_items: 2076,
        success_items: 2068,
        error_items: 8,
        skipped_items: 0,
        started_at: "2026-01-09T09:14:12Z",
        finished_at: "2026-01-09T09:27:34Z",
        error_message: "",
        checkpoint: {},
      },
      {
        id: 402,
        name: "mapear",
        order: 2,
        status: "completed",
        total_items: 105,
        processed_items: 105,
        success_items: 105,
        error_items: 0,
        skipped_items: 0,
        started_at: "2026-01-09T09:27:35Z",
        finished_at: "2026-01-09T09:40:12Z",
        error_message: "",
        checkpoint: { total_paginas: 105 },
      },
      {
        id: 403,
        name: "correlacionar",
        order: 3,
        status: "completed",
        total_items: 2079,
        processed_items: 2079,
        success_items: 2062,
        error_items: 0,
        skipped_items: 17,
        started_at: "2026-01-09T09:40:12Z",
        finished_at: "2026-01-09T09:48:44Z",
        error_message: "",
        checkpoint: {},
      },
      {
        id: 404,
        name: "incluir",
        order: 4,
        status: "completed",
        total_items: 2062,
        processed_items: 2062,
        success_items: 2050,
        error_items: 12,
        skipped_items: 0,
        started_at: "2026-01-09T09:48:45Z",
        finished_at: "2026-01-09T09:57:21Z",
        error_message: "",
        checkpoint: {},
      },
      {
        id: 405,
        name: "atualizar_cache",
        order: 5,
        status: "completed",
        total_items: 1,
        processed_items: 1,
        success_items: 1,
        error_items: 0,
        skipped_items: 0,
        started_at: "2026-01-09T09:57:21Z",
        finished_at: "2026-01-09T09:58:10Z",
        error_message: "",
        checkpoint: {},
      },
      {
        id: 406,
        name: "verificar",
        order: 6,
        status: "completed",
        total_items: 2062,
        processed_items: 2062,
        success_items: 2058,
        error_items: 4,
        skipped_items: 0,
        started_at: "2026-01-09T09:58:10Z",
        finished_at: "2026-01-09T10:02:50Z",
        error_message: "",
        checkpoint: {},
      },
      {
        id: 407,
        name: "incluir_hub",
        order: 7,
        status: "completed",
        total_items: 2058,
        processed_items: 2058,
        success_items: 1850,
        error_items: 0,
        skipped_items: 208,
        started_at: "2026-01-09T10:02:51Z",
        finished_at: "2026-01-09T10:08:30Z",
        error_message: "",
        checkpoint: {},
      },
    ],
  },
  {
    id: 122,
    created_at: "2026-01-08T18:59:30Z",
    updated_at: "2026-01-08T18:59:30Z",
    started_at: null,
    finished_at: null,
    status: "queued",
    mode: "pavcob",
    limit: 200,
    requested_by: 7,
    input_name: "NOTAS NOVEMBRO.xlsx",
    input_s3_key: "nf_docs/runs/122/input/NOTAS NOVEMBRO.xlsx",
    current_planilha_s3_key: "nf_docs/runs/122/input/NOTAS NOVEMBRO.xlsx",
    output_s3_key: "",
    current_stage: "",
    pause_requested: false,
    error_message: "",
    run_config: { workers: 4, mode: "pavcob", dry_run: true, import_enabled: false, import_ref: "Preview Novembro" },
    stages: [
      {
        id: 301,
        name: "processar",
        order: 1,
        status: "pending",
        total_items: 0,
        processed_items: 0,
        success_items: 0,
        error_items: 0,
        skipped_items: 0,
        started_at: null,
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
      {
        id: 302,
        name: "mapear",
        order: 2,
        status: "pending",
        total_items: 0,
        processed_items: 0,
        success_items: 0,
        error_items: 0,
        skipped_items: 0,
        started_at: null,
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
      {
        id: 303,
        name: "correlacionar",
        order: 3,
        status: "pending",
        total_items: 0,
        processed_items: 0,
        success_items: 0,
        error_items: 0,
        skipped_items: 0,
        started_at: null,
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
      {
        id: 304,
        name: "incluir",
        order: 4,
        status: "pending",
        total_items: 0,
        processed_items: 0,
        success_items: 0,
        error_items: 0,
        skipped_items: 0,
        started_at: null,
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
      {
        id: 305,
        name: "atualizar_cache",
        order: 5,
        status: "pending",
        total_items: 0,
        processed_items: 0,
        success_items: 0,
        error_items: 0,
        skipped_items: 0,
        started_at: null,
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
      {
        id: 306,
        name: "verificar",
        order: 6,
        status: "pending",
        total_items: 0,
        processed_items: 0,
        success_items: 0,
        error_items: 0,
        skipped_items: 0,
        started_at: null,
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
      {
        id: 307,
        name: "incluir_hub",
        order: 7,
        status: "pending",
        total_items: 0,
        processed_items: 0,
        success_items: 0,
        error_items: 0,
        skipped_items: 0,
        started_at: null,
        finished_at: null,
        error_message: "",
        checkpoint: {},
      },
    ],
  },
]

let nextRunId = 125
let nextStageId = 600
let nextEventId = 2000
let nextFileId = 3000

const ITEMS = [
  {
    id: 900,
    run: 124,
    stage: 501,
    item_key: "linha:163",
    status: "completed",
    message: "Nota processada com sucesso",
    metadata: {
      pasta: 757166,
      sinistro: "010353154601182",
      nf: 814,
      idr: "dzJYNGxRb2V1TkFET2o4YWkyWWpxUT090",
      status: "CONCLUIDO",
    },
    created_at: "2026-01-12T16:01:10Z",
    updated_at: "2026-01-12T16:01:12Z",
  },
  {
    id: 901,
    run: 124,
    stage: 501,
    item_key: "linha:164",
    status: "completed",
    message: "Nota processada com sucesso",
    metadata: {
      pasta: 632707,
      sinistro: "010203153616909",
      nf: 815,
      idr: "bGc3ZnUxdWVWL29KcGRxTFE4NHpDdz090",
      status: "CONCLUIDO",
    },
    created_at: "2026-01-12T16:01:12Z",
    updated_at: "2026-01-12T16:01:16Z",
  },
  {
    id: 902,
    run: 124,
    stage: 501,
    item_key: "linha:165",
    status: "failed",
    message: "Erro ao emitir nota",
    metadata: { pasta: 572076, sinistro: "010423152642837", nf: 819, idr: "", status: "ERRO" },
    created_at: "2026-01-12T16:01:18Z",
    updated_at: "2026-01-12T16:01:18Z",
  },
  {
    id: 910,
    run: 124,
    stage: 502,
    item_key: "pagina:1",
    status: "completed",
    message: "mapeada",
    metadata: { sinistros: 20, erros: 0 },
    created_at: "2026-01-12T16:07:34Z",
    updated_at: "2026-01-12T16:07:41Z",
  },
  {
    id: 911,
    run: 124,
    stage: 502,
    item_key: "pagina:2",
    status: "completed",
    message: "mapeada",
    metadata: { sinistros: 20, erros: 0 },
    created_at: "2026-01-12T16:07:42Z",
    updated_at: "2026-01-12T16:07:49Z",
  },
  {
    id: 912,
    run: 124,
    stage: 502,
    item_key: "pagina:7",
    status: "failed",
    message: "erro",
    metadata: { sinistros: 14, erros: 2 },
    created_at: "2026-01-12T16:08:06Z",
    updated_at: "2026-01-12T16:08:10Z",
  },
  {
    id: 920,
    run: 124,
    stage: 503,
    item_key: "linha:148",
    status: "completed",
    message: "correlacionada",
    metadata: { sinistro: "010563154602196", parcela: 3, numseq_cp: "1235449068" },
    created_at: "2026-01-12T16:12:40Z",
    updated_at: "2026-01-12T16:12:40Z",
  },
  {
    id: 921,
    run: 124,
    stage: 503,
    item_key: "linha:149",
    status: "skipped",
    message: "ja_correlacionada",
    metadata: { sinistro: "011093154312659", parcela: 6, numseq_cp: "1234287486" },
    created_at: "2026-01-12T16:12:41Z",
    updated_at: "2026-01-12T16:12:41Z",
  },
  {
    id: 930,
    run: 124,
    stage: 504,
    item_key: "linha:150",
    status: "completed",
    message: "incluida",
    metadata: {
      sinistro: "010353154601182",
      parcela: 4,
      numseq_cp: "1234816008",
      nf: 814,
    },
    created_at: "2026-01-12T16:19:13Z",
    updated_at: "2026-01-12T16:19:13Z",
  },
  {
    id: 931,
    run: 124,
    stage: 504,
    item_key: "linha:151",
    status: "completed",
    message: "incluida",
    metadata: {
      sinistro: "010203153616909",
      parcela: 1,
      numseq_cp: "1233781734",
      nf: 815,
    },
    created_at: "2026-01-12T16:19:16Z",
    updated_at: "2026-01-12T16:19:16Z",
  },
  {
    id: 932,
    run: 124,
    stage: 504,
    item_key: "linha:152",
    status: "skipped",
    message: "parcela_duplicada",
    metadata: {
      sinistro: "010423152642837",
      parcela: 27,
      numseq_cp: "1233412079",
      nf: 819,
    },
    created_at: "2026-01-12T16:19:19Z",
    updated_at: "2026-01-12T16:19:19Z",
  },
  {
    id: 916,
    run: 123,
    stage: 406,
    item_key: "linha:120",
    status: "completed",
    message: "verificada",
    metadata: { sinistro: "010083153597178", nf: 924, status_conferencia: "OK" },
    created_at: "2026-01-09T10:00:12Z",
    updated_at: "2026-01-09T10:00:20Z",
  },
]

const EVENTS = [
  {
    id: 1500,
    run: 124,
    stage: null,
    level: "info",
    message: "Pipeline disparada",
    metadata: {},
    created_at: "2026-01-12T16:00:02Z",
  },
  {
    id: 1501,
    run: 124,
    stage: 501,
    level: "info",
    message: "Planilha carregada: 2076 linhas",
    metadata: { arquivo: "HDI_2026_ORIGINAL.xlsx" },
    created_at: "2026-01-12T16:00:04Z",
  },
  {
    id: 1502,
    run: 124,
    stage: 502,
    level: "info",
    message: "Total de paginas encontrado: 105",
    metadata: { paginas: 105 },
    created_at: "2026-01-12T16:07:33Z",
  },
  {
    id: 1503,
    run: 124,
    stage: 502,
    level: "info",
    message: "Mapeamento concluido: Paginas: 105/105 (100.0%) | Sinistros: 2080 | Novos: 1663 | Atualizados: 0 | Erros: 0",
    metadata: { paginas: 105, sinistros: 2080, novos: 1663, atualizados: 0, erros: 0 },
    created_at: "2026-01-12T16:12:25Z",
  },
  {
    id: 1504,
    run: 124,
    stage: 504,
    level: "warning",
    message: "Relatorio de ambiguidades gerado",
    metadata: { caminho: "/var/www/nfe_gen/logs/hdi_ambiguidades_20260112_160011.csv" },
    created_at: "2026-01-12T16:19:11Z",
  },
  {
    id: 1505,
    run: 124,
    stage: 504,
    level: "error",
    message: "Inclusao bloqueada para 6 linhas com parcela duplicada",
    metadata: { linhas: 6 },
    created_at: "2026-01-12T16:19:11Z",
  },
  {
    id: 1506,
    run: 124,
    stage: 504,
    level: "info",
    message: "Incluindo NF 814 no sinistro 010353154601182",
    metadata: { sinistro: "010353154601182", nf: 814, parcela: 4 },
    created_at: "2026-01-12T16:19:13Z",
  },
  {
    id: 1510,
    run: 123,
    stage: null,
    level: "info",
    message: "Pipeline finalizada com sucesso",
    metadata: {},
    created_at: "2026-01-09T10:02:50Z",
  },
  {
    id: 1511,
    run: 123,
    stage: 401,
    level: "info",
    message: "Planilha carregada: 2076 linhas",
    metadata: { arquivo: "HDI_2026_ORIGINAL.xlsx" },
    created_at: "2026-01-09T09:14:10Z",
  },
  {
    id: 1512,
    run: 123,
    stage: 406,
    level: "info",
    message: "Verificacao finalizada com sucesso",
    metadata: {},
    created_at: "2026-01-09T10:02:50Z",
  },
]

const FILES = [
  {
    id: 2100,
    run: 124,
    stage: null,
    file_type: "input",
    s3_key: "nf_docs/runs/124/input/HDI_2026_ORIGINAL.xlsx",
    filename: "HDI_2026_ORIGINAL.xlsx",
    size_bytes: 352948,
    created_at: "2026-01-12T16:00:02Z",
  },
  {
    id: 2101,
    run: 124,
    stage: 501,
    file_type: "planilha",
    s3_key: "nf_docs/runs/124/stage/processar/planilha.xlsx",
    filename: "planilha.xlsx",
    size_bytes: 380214,
    created_at: "2026-01-12T16:07:32Z",
  },
  {
    id: 2102,
    run: 124,
    stage: 501,
    file_type: "log",
    s3_key: "nf_docs/runs/124/stage/processar/logs/nfe_pipeline_124_processar.log",
    filename: "nfe_pipeline_124_processar.log",
    size_bytes: 1049234,
    created_at: "2026-01-12T16:07:32Z",
  },
  {
    id: 2103,
    run: 124,
    stage: 502,
    file_type: "log",
    s3_key: "nf_docs/runs/124/stage/mapear/logs/nfe_pipeline_124_mapear.log",
    filename: "nfe_pipeline_124_mapear.log",
    size_bytes: 684221,
    created_at: "2026-01-12T16:12:25Z",
  },
  {
    id: 2104,
    run: 124,
    stage: 503,
    file_type: "db",
    s3_key: "nf_docs/runs/124/db/nfe_gen.db",
    filename: "nfe_gen.db",
    size_bytes: 4829180,
    created_at: "2026-01-12T16:12:30Z",
  },
  {
    id: 2105,
    run: 124,
    stage: 504,
    file_type: "report",
    s3_key: "nf_docs/runs/124/docs/reports/hdi_ambiguidades_20260112_160011.csv",
    filename: "hdi_ambiguidades_20260112_160011.csv",
    size_bytes: 68231,
    created_at: "2026-01-12T16:19:11Z",
  },
  {
    id: 2106,
    run: 124,
    stage: 504,
    file_type: "xml",
    s3_key:
      "nf_docs/HDI/12_01_2026_a1b2c3d4/010353154601182/814_NFSe_12_01_2026_dzJYNGxRb2V1TkFET2o4YWkyWWpxUT090.xml",
    filename: "814_NFSe_12_01_2026_dzJYNGxRb2V1TkFET2o4YWkyWWpxUT090.xml",
    size_bytes: 34321,
    created_at: "2026-01-12T16:19:18Z",
  },
  {
    id: 2107,
    run: 124,
    stage: 504,
    file_type: "pdf",
    s3_key:
      "nf_docs/HDI/12_01_2026_a1b2c3d4/010353154601182/814_DANFSe_12_01_2026_dzJYNGxRb2V1TkFET2o4YWkyWWpxUT090.pdf",
    filename: "814_DANFSe_12_01_2026_dzJYNGxRb2V1TkFET2o4YWkyWWpxUT090.pdf",
    size_bytes: 88321,
    created_at: "2026-01-12T16:19:18Z",
  },
  {
    id: 2110,
    run: 123,
    stage: null,
    file_type: "input",
    s3_key: "nf_docs/runs/123/input/HDI_2026_ORIGINAL.xlsx",
    filename: "HDI_2026_ORIGINAL.xlsx",
    size_bytes: 352948,
    created_at: "2026-01-09T09:14:10Z",
  },
  {
    id: 2111,
    run: 123,
    stage: 401,
    file_type: "log",
    s3_key: "nf_docs/runs/123/stage/processar/logs/nfe_pipeline_123_processar.log",
    filename: "nfe_pipeline_123_processar.log",
    size_bytes: 983215,
    created_at: "2026-01-09T09:27:34Z",
  },
  {
    id: 2112,
    run: 123,
    stage: 406,
    file_type: "planilha",
    s3_key: "nf_docs/runs/123/stage/verificar/planilha.xlsx",
    filename: "planilha.xlsx",
    size_bytes: 380214,
    created_at: "2026-01-09T10:02:50Z",
  },
  {
    id: 2113,
    run: 123,
    stage: 401,
    file_type: "xml",
    s3_key:
      "nf_docs/HDI/09_01_2026_b4c5d6e7/757166/814_NFSe_09_01_2026_dzJYNGxRb2V1TkFET2o4YWkyWWpxUT090.xml",
    filename: "814_NFSe_09_01_2026_dzJYNGxRb2V1TkFET2o4YWkyWWpxUT090.xml",
    size_bytes: 37218,
    created_at: "2026-01-09T09:14:12Z",
  },
  {
    id: 2114,
    run: 123,
    stage: 401,
    file_type: "pdf",
    s3_key:
      "nf_docs/HDI/09_01_2026_b4c5d6e7/757166/814_DANFSe_09_01_2026_dzJYNGxRb2V1TkFET2o4YWkyWWpxUT090.pdf",
    filename: "814_DANFSe_09_01_2026_dzJYNGxRb2V1TkFET2o4YWkyWWpxUT090.pdf",
    size_bytes: 112320,
    created_at: "2026-01-09T09:14:12Z",
  },
  {
    id: 2115,
    run: 123,
    stage: 403,
    file_type: "db",
    s3_key: "nf_docs/runs/123/db/nfe_gen.db",
    filename: "nfe_gen.db",
    size_bytes: 4698211,
    created_at: "2026-01-09T09:48:44Z",
  },
]

const NOTIFICATIONS = [
  {
    id: 3100,
    run: 124,
    stage: 501,
    user: 7,
    event_type: "stage_completed",
    message: "Etapa Processar NFEs concluida",
    created_at: "2026-01-12T16:07:32Z",
    read_at: null,
  },
  {
    id: 3101,
    run: 124,
    stage: 502,
    user: 7,
    event_type: "stage_completed",
    message: "Etapa Mapear paginas concluida",
    created_at: "2026-01-12T16:12:25Z",
    read_at: null,
  },
  {
    id: 3102,
    run: 123,
    stage: 406,
    user: 7,
    event_type: "run_completed",
    message: "Pipeline finalizada com sucesso",
    created_at: "2026-01-09T10:02:50Z",
    read_at: "2026-01-09T11:10:00Z",
  },
]

const store = {
  runs: RUNS,
  items: ITEMS,
  events: EVENTS,
  files: FILES,
  notifications: NOTIFICATIONS,
}

function clone(data) {
  return JSON.parse(JSON.stringify(data))
}

function withLatency(data) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(data), 200)
  })
}

function withMock(data) {
  const payload = clone(data)
  payload.mock = true
  return withLatency(payload)
}

function parseIntParam(value, fallback) {
  const parsed = parseInt(value, 10)
  return Number.isNaN(parsed) ? fallback : parsed
}

function filterByList(value, allowed) {
  if (!allowed || allowed.length === 0) return true
  return allowed.includes(value)
}

function normalizeList(value) {
  if (!value) return null
  if (Array.isArray(value)) return value
  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)
}

function paginate(list, params) {
  const pageSize = parseIntParam(params && params.page_size, 20)
  const page = parseIntParam(params && params.page, 1)
  const start = (page - 1) * pageSize
  const results = list.slice(start, start + pageSize)
  return { count: list.length, results: results }
}

function sortRuns(a, b) {
  if (a.created_at > b.created_at) return -1
  if (a.created_at < b.created_at) return 1
  return b.id - a.id
}

function sortByFieldDesc(field) {
  return (a, b) => {
    if (a[field] > b[field]) return -1
    if (a[field] < b[field]) return 1
    return b.id - a.id
  }
}

function createStages() {
  return STAGE_SEQUENCE.map((stage) => {
    const stageId = nextStageId
    nextStageId += 1
    return {
      id: stageId,
      name: stage.name,
      order: stage.order,
      status: "pending",
      total_items: 0,
      processed_items: 0,
      success_items: 0,
      error_items: 0,
      skipped_items: 0,
      started_at: null,
      finished_at: null,
      error_message: "",
      checkpoint: {},
    }
  })
}

function findRun(runId) {
  return store.runs.find((run) => run.id === Number(runId))
}

export function listRuns(params) {
  const runs = clone(store.runs).sort(sortRuns)
  return withMock(paginate(runs, params))
}

export function getRun(runId) {
  const run = findRun(runId)
  if (!run) {
    return withMock({ detail: "Not found", status: 404 })
  }
  return withMock(clone(run))
}

export function createRun(file, mode, limit, options) {
  const runId = nextRunId
  nextRunId += 1
  const createdAt = new Date().toISOString()
  const name = file && file.name ? file.name : mode === "pavcob" ? "NOTAS NOVEMBRO.xlsx" : mode === "santander" ? "SANTANDER_2026_ORIGINAL.xlsx" : "HDI_2026_ORIGINAL.xlsx"
  const config = options || {}

  const newRun = {
    id: runId,
    created_at: createdAt,
    updated_at: createdAt,
    started_at: null,
    finished_at: null,
    status: "queued",
    mode: mode || "hdi",
    limit: limit || null,
    requested_by: 7,
    input_name: name,
    input_s3_key: "nf_docs/runs/" + runId + "/input/" + name,
    current_planilha_s3_key: "nf_docs/runs/" + runId + "/input/" + name,
    output_s3_key: "",
    current_stage: "processar",
    pause_requested: false,
    error_message: "",
    run_config: {
      mode: mode || "hdi",
      dry_run: typeof config.dry_run === "boolean" ? config.dry_run : false,
      import_enabled: typeof config.import_enabled === "boolean" ? config.import_enabled : true,
      import_ref: config.import_ref || "",
    },
    stages: createStages(),
  }

  store.runs.unshift(newRun)
  store.events.unshift({
    id: nextEventId,
    run: runId,
    stage: null,
    level: "info",
    message: "Pipeline disparada (mock)",
    metadata: {},
    created_at: createdAt,
  })
  nextEventId += 1

  store.files.unshift({
    id: nextFileId,
    run: runId,
    stage: null,
    file_type: "input",
    s3_key: "nf_docs/runs/" + runId + "/input/" + name,
    filename: name,
    size_bytes: file && file.size ? file.size : 0,
    created_at: createdAt,
  })
  nextFileId += 1

  return withMock(clone(newRun))
}

export function pauseRun(runId) {
  const run = findRun(runId)
  if (run) {
    run.pause_requested = true
    if (run.status === "running") {
      run.status = "paused"
    }
    if (run.current_stage) {
      const stage = run.stages.find((item) => item.name === run.current_stage)
      if (stage && stage.status === "running") {
        stage.status = "paused"
      }
    }
  }
  return withMock({ status: "pause_requested" })
}

export function resumeRun(runId) {
  const run = findRun(runId)
  if (run) {
    run.pause_requested = false
    if (run.status === "paused") {
      run.status = "running"
    }
    if (run.current_stage) {
      const stage = run.stages.find((item) => item.name === run.current_stage)
      if (stage && stage.status === "paused") {
        stage.status = "running"
      }
    }
  }
  return withMock({ status: "resume_queued" })
}

export function getTemplate(mode) {
  return withMock({
    mode: mode,
    s3_key: "nf_docs/templates/" + mode + ".xlsx",
    url: "/mock/templates/" + mode + ".xlsx",
  })
}

export function downloadTemplate(mode) {
  const blob = new Blob(["mock-template"], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  })
  return withLatency({
    blob: blob,
    filename: mode.toUpperCase() + "_TEMPLATE.xlsx",
    mock: true,
  })
}

export function downloadDocs(runId) {
  const blob = new Blob(["mock-zip"], { type: "application/zip" })
  return withLatency({
    blob: blob,
    filename: "nfe_docs_run_" + runId + ".zip",
    mock: true,
  })
}

export function getRequiredColumns(mode) {
  const base = ["PASTA", "SINISTRO", "NF", "IDR", "STATUS"]
  const hdiOnly = ["NUMSEQ_CP", "PARCELA", "DATA_EMISSAO"]
  const pavcobOnly = ["VALOR", "DATA_PAGAMENTO", "CLIENTE"]
  const columns = mode === "pavcob" ? base.concat(pavcobOnly) : base.concat(hdiOnly)
  return withMock({ mode: mode, required_columns: columns })
}

export function listItems(params) {
  const runId = params && params.run ? Number(params.run) : null
  const stageId = params && params.stage ? Number(params.stage) : null
  const statusFilter = normalizeList(params && params.status)

  const filtered = store.items.filter((item) => {
    if (runId && item.run !== runId) return false
    if (stageId && item.stage !== stageId) return false
    if (!filterByList(item.status, statusFilter)) return false
    return true
  })

  const sorted = filtered.slice().sort(sortByFieldDesc("updated_at"))
  return withMock(paginate(sorted, params))
}

export function listEvents(params) {
  const runId = params && params.run ? Number(params.run) : null
  const stageId = params && params.stage ? Number(params.stage) : null
  const levelFilter = normalizeList(params && params.level)

  const filtered = store.events.filter((event) => {
    if (runId && event.run !== runId) return false
    if (stageId && Number(event.stage) !== stageId) return false
    if (!filterByList(event.level, levelFilter)) return false
    return true
  })

  const sorted = filtered.slice().sort(sortByFieldDesc("created_at"))
  return withMock(paginate(sorted, params))
}

export function listFiles(params) {
  const runId = params && params.run ? Number(params.run) : null
  const stageId = params && params.stage ? Number(params.stage) : null
  const typeFilter = normalizeList(params && params.file_type)

  const filtered = store.files.filter((file) => {
    if (runId && file.run !== runId) return false
    if (stageId && Number(file.stage) !== stageId) return false
    if (!filterByList(file.file_type, typeFilter)) return false
    return true
  })

  const sorted = filtered.slice().sort(sortByFieldDesc("created_at"))
  return withMock(paginate(sorted, params))
}

export function listNotifications(params) {
  const runId = params && params.run ? Number(params.run) : null
  const filtered = store.notifications.filter((notification) => {
    if (runId && notification.run !== runId) return false
    return true
  })

  const sorted = filtered.slice().sort(sortByFieldDesc("created_at"))
  return withMock(paginate(sorted, params))
}

export function markNotificationRead(notificationId) {
  const notification = store.notifications.find((item) => item.id === Number(notificationId))
  if (notification && !notification.read_at) {
    notification.read_at = new Date().toISOString()
  }
  return withMock({ status: "ok" })
}

export function listEmitidas(params) {
  return withMock(paginate([], params))
}

export default {
  listRuns,
  getRun,
  createRun,
  pauseRun,
  resumeRun,
  getTemplate,
  downloadTemplate,
  downloadDocs,
  getRequiredColumns,
  listItems,
  listEvents,
  listFiles,
  listNotifications,
  listEmitidas,
  markNotificationRead,
}



// WEBPACK FOOTER //
// ./src/components/NFePipeline/services/nfePipeline.mock.js